import styled from "styled-components";

export const WrapperTextArea = styled.div`
  min-width: auto;
  max-width: 100%;
  padding: 10px 0px;
  textarea.ant-input {
    border-radius: 8px;
    height: ${({ height }) => height || "80px"};
    width: ${({ width }) => width || "100%"};
    border-color: ${({ border }) => border || "#dfe1e7"};
    color: #000;
  }
  .ant-input:focus,
  .ant-input-focused {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
    border-right-width: 1px;
    outline: 0;
  }
  .ant-input:hover {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
    border-right-width: 1px;
  }
  .ant-input-textarea-show-count::after {
    display: none;
  }
`;
